export class ViolationTemplate
{
    id: number;
    organizationId: number;
    title: string;
    message: string;

    constructor(request: any) {
        this.id = request.id;
        this.organizationId = request.organizationId;
        this.title = request.title || null;
        this.message = request.message || null;
    }
}
